import React, { useState } from 'react';
import cn from 'classnames';
import { StickyDataTable, dataTableStyles } from '@dealroadshow/uikit/core/components/Table/DataTable';
import baseStyles from '@/dataroom/ui/components/Landing/researchRoom/tenantResearchRoomStyles.scss';
import IconSelect from '@/Framework/UI/Pages/Landing/Sections/Form/CurrenciesSelect';
import { currencyIcons } from '@/Framework/UI/Pages/Landing/Sections/constants';
import SectionHeader from '@/Framework/UI/Pages/Landing/Sections/SectionHeader';
import { staticTableCollection, tableColumns } from './constants';
import StartActions from '@/dataroom/ui/components/Landing/researchRoom/components/StartActions';
import styles from './pricingTable.scss';

const pricingMap = {
  dataroomOneGBSize: (
    <>
      <span className={ styles.bold }>1 Bookrunner</span>
    </>
  ),
};

const prices = {
  AUD: '$11,400',
  CAD: '$10,300',
  CNY: '¥54,500',
  EUR: '€7,000',
  GBP: '£5,900',
  JPY: '¥1,175,000',
  USD: '$7,500',
};

const currenciesCollection = [
  {
    id: 'e20ebdcf-00ae-45e0-8cd1-fc71536d35e6',
    abbreviation: 'AUD',
    description: 'Australian Dollar',
    symbol: '$',
    isDefault: false,
  },
  {
    id: '767af800-f419-4c96-961c-99e8eaf50fac',
    abbreviation: 'CAD',
    description: 'Canadian Dollar',
    symbol: '$',
    isDefault: false,
  },
  {
    id: 'd9e995d9-6637-41c0-97f5-28318a15646d',
    abbreviation: 'CNY',
    description: 'Chinese Yuan',
    symbol: '\u00a5',
    isDefault: false,
  },
  {
    id: 'b409fa81-54d0-4906-9d1e-4b6dbc3d0187',
    abbreviation: 'EUR',
    description: 'Euro',
    symbol: '\u20ac',
    isDefault: false,
  },
  {
    id: '03f15dd6-b23e-4ab3-b302-89c499aca4fd',
    abbreviation: 'GBP',
    description: 'Great Britain Pound',
    symbol: '\u00a3',
    isDefault: false,
  },
  {
    id: '6863959e-1bdc-422e-8fb2-66b11958a093',
    abbreviation: 'JPY',
    description: 'Japanese Yen',
    symbol: '\u00a5',
    isDefault: false,
  },
  {
    id: '96e6bf40-3b92-4501-943d-282deee59a23',
    abbreviation: 'USD',
    description: 'US Dollar',
    symbol: '$',
    isDefault: true,
  },
].map(({
  id,
  abbreviation,
}) => ({
  value: id,
  label: abbreviation,
}));

const defaultCurrencyId = currenciesCollection.filter((item) => item.label === 'USD')[0]?.value;

const PricingTable = () => {
  const [currency, setCurrency] = useState(defaultCurrencyId);
  const handleCurrencyChange = (selectedCurrency) => {
    setCurrency(selectedCurrency.value);
  };

  const currencies = currenciesCollection.map((item) => ({
    ...item,
    icon: currencyIcons[item.label],
  }));

  const currentCurrency = currenciesCollection.find(({ value }) => value === currency)?.label;

  const tableCollection = [{
    name: 'dataroomOneGBSize',
    pricePerDeal: prices[currentCurrency],
  }].reduce((collection, item) => ([
    ...collection, {
      name: pricingMap[item.name],
      pricePerDeal: (
        <span>{ item.pricePerDeal }</span>
      ),
    },
  ]), [])
    .concat(staticTableCollection);

  return (
    <div className={ cn(styles.pricingWrp, baseStyles.mdContainer) }>
      <SectionHeader
        title="ResearchRoom Per-Deal Pricing."
        description="ResearchRoom is committed to providing industry leading capability at an industry leading price, without long term commitments."
        maxWidth={ 860 }
      />
      <div className={ styles.pricingContentWrp }>
        <div className={ styles.pricingTableWrp }>
          <StickyDataTable
            className={ dataTableStyles.isHoverable }
            dataTest="dealVdrPricingStickyDataTable"
            columns={ tableColumns }
            data={ tableCollection }
          />
        </div>
        <div className={ styles.footer }>
          <div className={ styles.footerTitleWrp }>
            <div>
              Prefer not to pay in USD?
            </div>
            <div>
              Select other currencies to view ResearchRoom pricing.
            </div>
          </div>
          <div className={ styles.currencySelector }>
            <IconSelect
              name="currency"
              options={ currencies }
              value={ currency }
              onChange={ handleCurrencyChange }
              disabled={ false }
              isNarrow
            />
          </div>
        </div>
        <div className={ styles.contactUs }>
          <div className={ styles.contactUsTitle }>
            Bundle Pre-IPO Research Distribution with Deal Roadshow
          </div>
          <div className={ styles.contactUsDescription }>
            Distributing pre-IPO research and hosting an online IPO? Connect with our global sales & support desk
            at{ ' ' }
            <a
              className={ styles.contactUsPhone }
              href="tel:+18889976610"
            >
              +1 888 997 6610
            </a>{ ' ' }
            or email{ ' ' }
            <a
              href={ 'mailto:support@dealroadshow.com?subject=ResearchRoom Pricing Request: Custom %26 Enterprise' }
              className={ styles.contactUsEmail }
            >
              support@dealroadshow.com
            </a>{ ' ' }
            for a custom bundle with ResearchRoom and Deal Roadshow.
          </div>
        </div>
      </div>
      <div className={ styles.getStartedButtonWrp }>
        <StartActions />
      </div>
    </div>
  );
};

export default PricingTable;
